import React from 'react'
import { createGlobalState } from 'react-hooks-global-state'
import { UserByYearAndMonth } from './services/user_service'

export interface DocumentData {
    readonly id: string
    readonly type: string
    readonly fromDate: number
    readonly dueDate: number
    readonly instalmentsCount: number
    readonly userID: string
    schedueldSMS: SMSData[]
    user: UserData
}

export interface UserData {
    readonly id: string
    readonly name: string
    readonly phoneNumber: string
}

export enum SMSStatus {
    sent,
    waiting,
    error,
}

export interface SMSData {
    readonly id: string
    readonly index: number
    readonly dueDate: number
    readonly documentId: string
    readonly twilioId: string | null
    readonly status: SMSStatus
}

export interface DocumentSMSData {
    readonly documentID: string
}


export interface GlobalState {
    documentsData: { [key: string]: DocumentData } | null,
}

const initialState: GlobalState = { documentsData: null }
const { useGlobalState } = createGlobalState<GlobalState>(initialState)

export default useGlobalState